import { render, staticRenderFns } from "./AsnTable.vue?vue&type=template&id=6f6da2b2&scoped=true&lang=pug"
import script from "./AsnTable.vue?vue&type=script&lang=js"
export * from "./AsnTable.vue?vue&type=script&lang=js"
import style0 from "./AsnTable.vue?vue&type=style&index=0&id=6f6da2b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6da2b2",
  null
  
)

export default component.exports